import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash/fp';

function useDeepCompare(deps) {
    const ref = useRef();

    if (!isEqual(ref.current, deps)) {
        ref.current = deps;
    }

    return ref.current;
}

export function useDeepEffect(fn, deps) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(fn, useDeepCompare(deps));
}
